import { IconCategoryData, IconUiCategory } from './iconToolTypes';

export const RECOMMENDED_CATEGORY: IconCategoryData = {
    slug: IconUiCategory.DEFAULT,
    title: 'Recommended',
    translationKey: 'categories.recommended',
};
export const LETTERS_CATEGORY: IconCategoryData = {
    slug: IconUiCategory.LETTERS,
    title: 'Letters & numbers',
    translationKey: 'categories.lettersAndNumbers',
};
